import { useState } from "react";
import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = 16, testid }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testid} aria-label={`${value} su 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= Math.round(value) ? "fill-amber-500 text-amber-500" : "fill-gray-200 text-gray-200"}
        aria-hidden="true"
      />
    ))}
  </span>
);

const LABELS = ["", "Pessimo", "Scarso", "Nella media", "Buono", "Eccellente"];

export const StarInput = ({ value, onChange, size = 32, testid }) => {
  const [hover, setHover] = useState(0);
  const shown = hover || value;
  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <div className="flex gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            data-testid={`${testid}-star-${i}`}
            onMouseEnter={() => setHover(i)}
            onClick={() => onChange(i)}
            className="transition-transform duration-150 hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-900 rounded"
            aria-label={`${i} stelle`}
          >
            <Star size={size} className={i <= shown ? "fill-amber-500 text-amber-500" : "fill-gray-100 text-gray-300"} />
          </button>
        ))}
      </div>
      <span className="text-sm font-medium text-gray-600 min-w-[90px]">{LABELS[shown]}</span>
    </div>
  );
};
